import DocEdit from './DocEdit';

export default DocEdit;
